import { createI18nText } from '@hilma/netina2all';

const tableText = createI18nText({
    he: {
        stations: {
            tableHeader: {
                name: 'שם התחנה',
                address: 'כתובת התחנה',
                userName: 'מנהל התחנה',
                userPhone: 'טלפון נייד',
                date: 'שעות פעילות'
            },
            stationClose: 'התחנה סגורה',
            open: 'פתוחה להזמנות',
            close: 'סגורה להזמנות',
            appointment: 'בתיאום מראש',
            moreDetails: 'פרטים נוספים',
            accessible: 'יש גישה לכנים',
            notAccessible: 'אין גישה לנכים',
            allStations: 'כל התחנות',
            onlyAccessible: 'תחנות נגישות בלבד',
            pStation: 'לרכישה מתחנה זו'
        },
        navigation: {
            page: 'עמוד',
            outOf: 'מתוך'
        },
        err: 'אירעה שגיאה, נסו שנית מאוחר יותר',
        noResults: 'לא נמצאו תוצאות'
    },
    en: {
        stations: {
            tableHeader: {
                name: 'Station Name',
                address: 'Address',
                userName: 'Staiton Manager',
                userPhone: 'Phone Number',
                date: 'Opening Hours,'
            },
            stationClose: 'close',
            open: 'Open For Orders',
            close: 'Closed For Orders',
            appointment: 'by appointment',
            moreDetails: 'More details',
            accessible: 'Accessible',
            notAccessible: 'Not Accessible',
            allStations: 'All Stations',
            onlyAccessible: 'Accessible',
            pStation: 'Purchase through this station'
        },
        navigation: {
            page: 'page',
            outOf: 'out of'
        },
        err: 'An error occurred, please try again later',
        noResults: 'No results were found'
    }
});

export default tableText;